<template>
  <div class="favouriteMatches-section">
    <a-card>
      <template #title>
        <div class="mt-1">
          <div class="d-flex font-size-20">
            <span v-if="sectionTitle" class="section-title" :class="{ 'hidden-title': !showLabel }">
              {{ sectionTitle }}
            </span>
          </div>
        </div>
      </template>
      <template #extra>
        <div class="d-flex align-items-center section-extra font-size-20 text-right">
          <a-button type="primary" icon="plus" disabled>
            Add
          </a-button>
          <div v-if="isEditAvailable" style="margin-top: 0.1rem">
            <a-tooltip title="Edit section" placement="bottom">
              <a-icon @click="editSection" type="edit" class="main-tabs__sections__icons text-primary" />
            </a-tooltip>
          </div>
          <div>
            <a-tooltip v-if="index < maxIndex - 1 && isEditAvailable" title="Move down" placement="bottom">
              <a-icon @click="moveDown" type="down" class="movable move-down text-primary" />
            </a-tooltip>
            <a-icon v-else type="down" class="movable text-gray-5" />
          </div>
          <div>
            <a-tooltip v-if="index > 0 && isEditAvailable" title="Move up" placement="bottom">
              <a-icon @click="moveUp" type="up" class="movable move-up text-primary" />
            </a-tooltip>
            <a-icon v-else type="up" class="movable text-gray-5" />
          </div>
          <a href="javascript:" class="text-primary" @click.stop="changeStatusSection">
            <a-switch v-model="isActiveSectionStatus" :disabled="!isEditAvailable" />
          </a>
          <div class="dropDown-icon disabled  text-gray-5">
            <DropDownIcon disabled />
          </div>
        </div>
      </template>
      <template #cover>
        <div class="favourite-content">
          <span>В секции отображаются матчи, которые пользователь самостоятельно добавляет в раздел избранное.</span>
        </div>
      </template>
    </a-card>
  </div>
</template>
<script>
import DropDownIcon from '@/components/custom/icons/dropDownIcon.vue'

export default {
  name: 'favouriteMatchesSection',
  props: ['index', 'maxIndex', 'selectedLang', 'showLabel', 'isActive', 'localizations', 'sectionId', 'isEditAvailable'],
  components: {
    DropDownIcon,
  },
  data: () => ({
    isActiveSectionStatus: false,
    windowWidth: window.innerWidth,
  }),
  watch: {
    isActive(value) {
      this.isActiveSectionStatus = value
    },
  },
  computed: {
    sectionTitle() {
      const selectedLang = this.selectedLang === 'ru' ? 0 : 2
      const localization = this.localizations.find(section => section.lang_id === selectedLang)
      return localization ? localization.value : null
    },
  },
  created() {
    this.isActiveSectionStatus = this.isActive
  },
  methods: {
    editSection() {
      this.$emit('editSection', this.sectionId)
    },
    moveDown() {
      this.$emit('moveDownSection', this.sectionId, 1)
    },
    moveUp() {
      this.$emit('moveUpSection', this.sectionId, -1)
    },
    changeStatusSection() {
      this.$emit('changeStatusSection', this.sectionId, this.isActiveSectionStatus)
    },
  },
}
</script>
<style lang="scss" src="./style.module.scss" />
